import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import StatusPill from "../components/StatusPill";
import { ArrowLeft, Phone, Mail, MapPin } from "lucide-react";

export default function CustomerDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/customers/${id}`).then(({ data }) => setData(data)).catch(() => {});
  }, [id]);

  if (!data) return <div className="p-8 text-slate-500">Loading…</div>;
  const { customer, jobs } = data;

  return (
    <div className="p-8 lg:p-10" data-testid="customer-detail-page">
      <Link to="/customers" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 mb-4">
        <ArrowLeft className="w-4 h-4"/> Back to customers
      </Link>
      <div className="grid lg:grid-cols-3 gap-6">
        <div className="bg-white border border-slate-200 rounded-md p-6">
          <h2 className="font-display text-2xl font-semibold mb-1" data-testid="customer-name">{customer.name}</h2>
          <div className="space-y-2 text-sm text-slate-600 mt-4">
            {customer.phone && <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-slate-400"/>{customer.phone}</div>}
            {customer.email && <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-slate-400"/>{customer.email}</div>}
            {customer.address && <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-slate-400"/>{customer.address}</div>}
          </div>
          {customer.notes && (
            <div className="mt-6">
              <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 mb-2">Notes</div>
              <div className="text-sm text-slate-700 whitespace-pre-wrap">{customer.notes}</div>
            </div>
          )}
        </div>

        <div className="lg:col-span-2 bg-white border border-slate-200 rounded-md">
          <div className="px-6 py-4 border-b border-slate-200 font-display font-medium">Service history</div>
          <div className="divide-y divide-slate-100">
            {jobs.length === 0 && <div className="p-6 text-sm text-slate-500">No jobs yet.</div>}
            {jobs.map((j) => (
              <Link to={`/jobs/${j.id}`} key={j.id}
                className="flex items-center justify-between px-6 py-4 hover:bg-slate-50 transition-colors">
                <div>
                  <div className="text-sm font-medium">{j.service_type.replace("_", " ")}</div>
                  <div className="text-xs text-slate-500">{j.date} · {j.time} · ${j.price}</div>
                </div>
                <StatusPill status={j.status} />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
